import {RESERVATION_ERROR_MESSAGES, RESERVATION_EXPIRED_WITHOUT_RESEND_TEXT} from "../constants/reservation_copy";
import {IReservationCodeStepContentProps} from "../types/IReservationCodeStepContentProps";
import {IReservationError} from "../types/IReservationError";
import {IReservationNameForm} from "../types/IReservationNameForm";
import {IReservationResendView} from "../types/IReservationResendView";
import {ReservationFlowState} from "../types/ReservationFlowState";
import {getReservationResendView} from "./reservation_flow_reducer";
import {secondsUntil} from "./reservation_time";

export type ReservationCodeStepView = Pick<
    IReservationCodeStepContentProps,
    "isInitiating" | "isExpired" | "isLocked" | "hasError" | "errorMessage" | "failedError" | "retrySecondsLeft" | "resend"
>;

interface IReservationCountdowns {
    resend: IReservationResendView;
    retrySecondsLeft: number;
    // apart from the resend view, which shows "exhausted" over a lock once every code has been sent
    lockSecondsLeft: number;
}

const getCountdowns = (state: ReservationFlowState, now: number): IReservationCountdowns => ({
    resend: getReservationResendView(state, now),
    retrySecondsLeft: state.status === "failed" ? secondsUntil(state.retryAvailableAt, now) : 0,
    lockSecondsLeft: state.status === "code_entry" ? secondsUntil(state.lockedUntil, now) : 0
});

// a resend cooldown, a lock or a retry countdown is shown - the steps need a fresh `now` every second
export const hasReservationCountdown = (state: ReservationFlowState, now: number): boolean => {
    const {resend, retrySecondsLeft, lockSecondsLeft} = getCountdowns(state, now);

    return resend.secondsLeft > 0 || retrySecondsLeft > 0 || lockSecondsLeft > 0;
};

// a request is in flight - initiating, confirming or resending
export const isReservationRequestPending = (state: ReservationFlowState): boolean =>
    state.status === "initiating" || state.status === "confirming" || (state.status === "code_entry" && state.isResending);

// the failure the name form is shown for
export const isProfileNameFailure = (state: ReservationFlowState): boolean => state.status === "failed" && state.error.kind === "profile_incomplete";

const getErrorMessage = (state: ReservationFlowState, resend: IReservationResendView, isLocked: boolean): string | null => {
    if (state.status !== "code_entry") {
        return null;
    }

    // "wait a moment" is stale once the lock has lifted
    const error = state.error?.kind === "rate_limited" && !isLocked ? null : state.error;

    if (state.isExpired) {
        // a failed resend explains why no new code has come - the expiry copy would only ask for another resend
        if (error?.phase === "initiate") {
            return error.message;
        }

        return resend.state === "exhausted" ? RESERVATION_EXPIRED_WITHOUT_RESEND_TEXT : RESERVATION_ERROR_MESSAGES.expired;
    }

    return error?.message ?? null;
};

// The screen of the code step: the loader until the first code is on its way, the name form or the notice of a failure, otherwise the code form
export type ReservationCodeStepContentView =
    | {kind: "loading"}
    | {kind: "name"; nameForm: IReservationNameForm}
    | {kind: "failed"; error: IReservationError}
    | {kind: "code"};

export const getReservationCodeStepContentView = (
    props: Pick<IReservationCodeStepContentProps, "isInitiating" | "failedError" | "nameForm">
): ReservationCodeStepContentView => {
    const {isInitiating, failedError, nameForm} = props;

    if (isInitiating) {
        return {kind: "loading"};
    }

    // a rejected profile name is no dead end - it is corrected right here
    if (failedError?.kind === "profile_incomplete" && nameForm) {
        return {kind: "name", nameForm};
    }

    return failedError ? {kind: "failed", error: failedError} : {kind: "code"};
};

// What the code step shows for the flow state at `now`
export const getReservationCodeStepView = (state: ReservationFlowState, now: number): ReservationCodeStepView => {
    const {resend, retrySecondsLeft, lockSecondsLeft} = getCountdowns(state, now);
    const isLocked = lockSecondsLeft > 0;
    const errorMessage = getErrorMessage(state, resend, isLocked);

    return {
        isInitiating: state.status === "idle" || state.status === "initiating",
        isExpired: state.status === "code_entry" && state.isExpired,
        isLocked,
        // a confirm-phase error in code entry means the submitted code itself was rejected - never marked without the text that explains it
        hasError: errorMessage !== null && state.status === "code_entry" && state.error?.phase === "confirm",
        errorMessage,
        failedError: state.status === "failed" ? state.error : null,
        retrySecondsLeft,
        resend
    };
};
import {RESERVATION_ERROR_MESSAGES, RESERVATION_EXPIRED_WITHOUT_RESEND_TEXT} from "../constants/reservation_copy";
import {IReservationCodeStepContentProps} from "../types/IReservationCodeStepContentProps";
import {IReservationError} from "../types/IReservationError";
import {IReservationNameForm} from "../types/IReservationNameForm";
import {IReservationResendView} from "../types/IReservationResendView";
import {ReservationFlowState} from "../types/ReservationFlowState";
import {getReservationResendView} from "./reservation_flow_reducer";
import {secondsUntil} from "./reservation_time";

export type ReservationCodeStepView = Pick<
    IReservationCodeStepContentProps,
    "isInitiating" | "isExpired" | "isLocked" | "hasError" | "errorMessage" | "failedError" | "retrySecondsLeft" | "resend"
>;

interface IReservationCountdowns {
    resend: IReservationResendView;
    retrySecondsLeft: number;
    // apart from the resend view, which shows "exhausted" over a lock once every code has been sent
    lockSecondsLeft: number;
}

const getCountdowns = (state: ReservationFlowState, now: number): IReservationCountdowns => ({
    resend: getReservationResendView(state, now),
    retrySecondsLeft: state.status === "failed" ? secondsUntil(state.retryAvailableAt, now) : 0,
    lockSecondsLeft: state.status === "code_entry" ? secondsUntil(state.lockedUntil, now) : 0
});

// a resend cooldown, a lock or a retry countdown is shown - the steps need a fresh `now` every second
export const hasReservationCountdown = (state: ReservationFlowState, now: number): boolean => {
    const {resend, retrySecondsLeft, lockSecondsLeft} = getCountdowns(state, now);

    return resend.secondsLeft > 0 || retrySecondsLeft > 0 || lockSecondsLeft > 0;
};

// a request is in flight - initiating, confirming or resending
export const isReservationRequestPending = (state: ReservationFlowState): boolean =>
    state.status === "initiating" || state.status === "confirming" || (state.status === "code_entry" && state.isResending);

// the failure the name form is shown for
export const isProfileNameFailure = (state: ReservationFlowState): boolean => state.status === "failed" && state.error.kind === "profile_incomplete";

const getErrorMessage = (state: ReservationFlowState, resend: IReservationResendView, isLocked: boolean): string | null => {
    if (state.status !== "code_entry") {
        return null;
    }

    // "wait a moment" is stale once the lock has lifted
    const error = state.error?.kind === "rate_limited" && !isLocked ? null : state.error;

    if (state.isExpired) {
        // a failed resend explains why no new code has come - the expiry copy would only ask for another resend
        if (error?.phase === "initiate") {
            return error.message;
        }

        return resend.state === "exhausted" ? RESERVATION_EXPIRED_WITHOUT_RESEND_TEXT : RESERVATION_ERROR_MESSAGES.expired;
    }

    return error?.message ?? null;
};

// The screen of the code step: the loader until the first code is on its way, the name form or the notice of a failure, otherwise the code form
export type ReservationCodeStepContentView =
    | {kind: "loading"}
    | {kind: "name"; nameForm: IReservationNameForm}
    | {kind: "failed"; error: IReservationError}
    | {kind: "code"};

export const getReservationCodeStepContentView = (
    props: Pick<IReservationCodeStepContentProps, "isInitiating" | "failedError" | "nameForm">
): ReservationCodeStepContentView => {
    const {isInitiating, failedError, nameForm} = props;

    if (isInitiating) {
        return {kind: "loading"};
    }

    // a rejected profile name is no dead end - it is corrected right here
    if (failedError?.kind === "profile_incomplete" && nameForm) {
        return {kind: "name", nameForm};
    }

    return failedError ? {kind: "failed", error: failedError} : {kind: "code"};
};

// What the code step shows for the flow state at `now`
export const getReservationCodeStepView = (state: ReservationFlowState, now: number): ReservationCodeStepView => {
    const {resend, retrySecondsLeft, lockSecondsLeft} = getCountdowns(state, now);
    const isLocked = lockSecondsLeft > 0;
    const errorMessage = getErrorMessage(state, resend, isLocked);

    return {
        isInitiating: state.status === "idle" || state.status === "initiating",
        isExpired: state.status === "code_entry" && state.isExpired,
        isLocked,
        // a confirm-phase error in code entry means the submitted code itself was rejected - never marked without the text that explains it
        hasError: errorMessage !== null && state.status === "code_entry" && state.error?.phase === "confirm",
        errorMessage,
        failedError: state.status === "failed" ? state.error : null,
        retrySecondsLeft,
        resend
    };
};
